class DetailsModal extends HTMLElement {
    constructor() {
        super();
        this.detailsContainer = this.querySelector('details');
        this.summaryToggle = this.querySelector('summary');

        // Some header layouts (e.g. the mobile search toggle) render a bare
        // summary with no modal panel or close button. Bail out rather than
        // throwing, so those toggles keep their own behaviour.
        if (!this.detailsContainer || !this.summaryToggle) return;

        this.closeButton = this.querySelector('button[type="button"]');
        if (!this.closeButton) return;

        this.detailsContainer.addEventListener(
            'keyup',
            (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
        );

        this.summaryToggle.addEventListener(
            'click',
            this.onSummaryClick.bind(this)
        );

        this.closeButton.addEventListener(
            'click',
            this.close.bind(this)
        );

        this.summaryToggle.setAttribute('role', 'button');
        this.summaryToggle.setAttribute('aria-expanded', 'false');
    }

    isOpen() {
        return this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event) {
        event.preventDefault();

        event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
    }

    onBodyClick(event) {
        if (!this.contains(event.target)) this.close(false);
    }

    open(event) {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        event.target.closest('details').setAttribute('open', true);
        document.body.addEventListener('click', this.onBodyClickEvent);
        this.summaryToggle.setAttribute('aria-expanded', 'true');

        const firstInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
        trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), firstInput);
    }

    close(focusToggle = true) {
        removeTrapFocus(focusToggle ? this.summaryToggle : null);
        this.detailsContainer.removeAttribute('open');
        this.summaryToggle.setAttribute('aria-expanded', 'false');
        document.body.removeEventListener('click', this.onBodyClickEvent);
    }
}

customElements.define('details-modal', DetailsModal);
